// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"2cb33f9e","187":"c7b0f1c0"}[chunkId] + ".chunk.js";
};